var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImageLoaded)?_c('img',{staticClass:"poster",attrs:{"src":_vm.imgUrl}}):_c('div',{staticClass:"default-img",style:({ height: _vm.height + 'px'})})}
var staticRenderFns = []

export { render, staticRenderFns }